module.exports = __webpack_public_path__ + "static/img/bg-ar.aee0c0e2.png";